import { NURSE_REQUEST_RESOURCE } from '../api/resources';
import { createResourceSlice } from '../store/resource/createResourceSlice';

const nurseRequestsSlice = createResourceSlice({
    resource: NURSE_REQUEST_RESOURCE,
    byKey: 'careNeedIds',
    reducers: {
        // storeBulk creates one NurseRequest per agency in a single request,
        // so its fulfilled payload is an array of items instead of a single one.
        storeBulkFulfilled: (state, action) => {
            action.payload.forEach((item) => {
                nurseRequestsSlice.caseReducers.storeFulfilled(state, {
                    ...action,
                    payload: item,
                });
            });
        },

        // closeBulk closes every requested NurseRequest in a single request,
        // so its fulfilled payload is an array of items instead of a single one.
        closeBulkFulfilled: (state, action) => {
            action.payload.forEach((item) => {
                nurseRequestsSlice.caseReducers.updateFulfilled(state, {
                    ...action,
                    payload: item,
                });
            });
        },
    },
});

export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    storeBulkFulfilled,
    updateFulfilled,
    closeBulkFulfilled,
    destroyFulfilled,

    indexNurseRequests,
    showNurseRequest,
    storeNurseRequest,
    updateNurseRequest,
    archiveNurseRequest,
    restoreNurseRequest,
    destroyNurseRequest,
} = nurseRequestsSlice.actions;

export const storeNurseRequests = (params) => (dispatch, getState, api) =>
    api[NURSE_REQUEST_RESOURCE].storeBulk(params);

// Closes one or more NurseRequests (by id) in a single request/DB
// transaction, instead of a separate update per NurseRequest.
export const closeNurseRequests = (params) => (dispatch, getState, api) =>
    api[NURSE_REQUEST_RESOURCE].closeBulk(params);

export const {
    selectNurseRequestById,
    makeNurseRequestsByIdsSelector,
    selectAllNurseRequestIds,
    selectAllNurseRequests,
    selectNurseRequestsLoading,
    selectNurseRequestsInitialized,
    selectNurseRequestLoading,
    selectNurseRequestInitialized,
    selectNurseRequestIdsByCareNeedId,
    makeNurseRequestsByCareNeedIdSelector,
    selectNurseRequestLoadingByCareNeedId,
    selectNurseRequestInitializedByCareNeedId,
} = nurseRequestsSlice.selectors;

export const {
    useNurseRequests,
    useNurseRequest,
    useNurseRequestsByCareNeedId,
} = nurseRequestsSlice.hooks;

export default nurseRequestsSlice.reducer;
